import Constant from "../../Constants/Constants";

const initialState = {
  history: [],
  submitResponse: null,
  cancelResponse: null,
  loadingHistory: false,
  loadingSubmit: false,
  loadingCancel: false,
  error: null,
};

class Maintenance {
  static MaintenanceReducer = (state = initialState, action) => {
    switch (action.type) {
      case Constant.GET_MAINTENANCE_HISTORY_REQUEST:
        return {
          ...state,
          loadingHistory: true,
          error: null,
        };
      case Constant.GET_MAINTENANCE_HISTORY_SUCCESS:
        return {
          ...state,
          loadingHistory: false,
          history: action.payload ?? [],
          error: null,
        };
      case Constant.GET_MAINTENANCE_HISTORY_FAILURE:
        return {
          ...state,
          loadingHistory: false,
          error: action.payload,
        };

      case Constant.SUBMIT_MAINTENANCE_REQUEST:
        return {
          ...state,
          loadingSubmit: true,
          error: null,
        };
      case Constant.SUBMIT_MAINTENANCE_SUCCESS:
        return {
          ...state,
          loadingSubmit: false,
          submitResponse: action.payload,
          error: null,
        };
      case Constant.SUBMIT_MAINTENANCE_FAILURE:
        return {
          ...state,
          loadingSubmit: false,
          error: action.payload,
        };

      case Constant.CANCEL_MAINTENANCE_REQUEST:
        return {
          ...state,
          loadingCancel: true,
          error: null,
        };
      case Constant.CANCEL_MAINTENANCE_SUCCESS:
        return {
          ...state,
          loadingCancel: false,
          cancelResponse: action.payload,
          error: null,
        };
      case Constant.CANCEL_MAINTENANCE_FAILURE:
        return {
          ...state,
          loadingCancel: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
}

export default Maintenance;
